export default "__VITE_ASSET__059944b4__"